import React, { useState } from 'react'
import { storage, db } from '../../../firebase'
import {
    Box,
    Button,
    Card,
    CardHeader,
    Divider,
  } from '@mui/material';
import { Container } from 'semantic-ui-react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import InfoIcon from '@mui/icons-material/Info';

export default function FileUpload(props) {

    const [ref, setRef] = useState(null);
    const [srcImagen,setSrcImagen] = useState(props.defaultImg)
    const [show, setShow] = useState(false);
    const [Imagen, setImagen] = useState();
    const[errortype,setError]=useState(false);
    const[errorMjs,setErrorMsj]=useState(false);

    const[wiewButtons,setWiewButtons]=useState(true)
    const[wiewPdf,setwiewPdf]=useState(false)
    const[infoStatus,seTinfoStatus]=useState(props.status)

    const[isChange,setIsChange]=useState(false);
    //OBTENIENDO LA IMAGEN
    const changeImagen = e => {
        setImagen(e.target.files[0]);
        setIsChange(true)
        setWiewButtons(false)    
    }
    const descripcion = props.descripcion


    //FUNCION PARA GUARDAR LA IMAGEN EN FIREBASE
    const uploadImage = async () => {
        if(Imagen){
           try {
            setErrorMsj(false)
            const newRef = storage.ref(`documents/${props.prefixf}/${props.companyUid}/`).child(`${props.prefix}-${props.companyUid}`); // nombre del archivo
            setRef(newRef);

            if ((Imagen.type ==='image/jpeg')||(Imagen.type ==='image/jpg')||(Imagen.type ==='image/png')||(Imagen.type==='application/pdf')) {
                await newRef.put(Imagen);
                setWiewButtons(true)
                setError(false)
                setShow(false);
            }else{
                setError(true)
            }
            let urlImagen = await newRef.getDownloadURL()
            setSrcImagen(urlImagen)
            //console.log('la ul de la imagen es ' + urlImagen);
            seTinfoStatus(true)
            //companyImgRut
            await db.collection(`${process.env.REACT_APP_COL_COMPANIES}`).doc(props.companyUid).update({  
                companyImgDocsDocsii : urlImagen,
                statusDocsDocsii : true,
              });
        } catch (error) {
            alert(error);
        }
    }else{
        setErrorMsj(true)
    }
    };

    const handleModalOpen = async () => {
        setShow(true);
    }

    const handleModalClose = async () => {
        setShow(false);
        setImagen('')
        setErrorMsj(false)
        setError(false)
    }
    

    return (

        <Card className='typeMiniforms'>
            {
            props.authorized===false?(<div className="alert alert-info  minimalsize" role="alert">
                {
             infoStatus?(<><div className="alert alert-success minimalsize" role="alert"><InfoIcon/>{props.title} {infoStatus}</div></>):
                        (<><div className="alert alert-warning  minimalsize" role="alert"><InfoIcon/>El administrador debe registrar la documentacion</div></>)
               }

            </div>):(<>  
        <CardHeader
         subheader={(<>{descripcion}</>)}
         title={(<><div onClick={handleModalOpen} > <button className="btn btn-primary"><SettingsIcon/>{props.title}</button></div></>)}
        />
        {
            errortype===true?(<div className="alert alert-danger m-1" role="alert">
            Formato invalido.
          </div>):(<span></span>)
        }
        {
            errorMjs===true?(<div className="alert alert-danger m-1" role="alert">
            Seleccione una imagen.
          </div>):(<span></span>)
        }
        <Divider />
        <Container className='' id="">
        {
            wiewPdf===true?(<span> <img width={30} src='https://firebasestorage.googleapis.com/v0/b/bicci-7ed2f.appspot.com/o/webfrontend%2Fweb-biccixpress%2Fimagenpdf-1.jpg?alt=media&token=f6be0831-e473-483a-bc31-6cadd391fbdd' alt =""/> Documento PDF </span>):(<span> <img width={150} src={srcImagen} alt =""/>  </span>)
        }
       
        
        </Container>
            <Divider />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: 2
                }} >
                <div className="cardUploaps" hidden={!show} >
                    <div>
                    {
                        wiewButtons===true?(<span><label htmlFor={props.objRef}><CloudUploadIcon></CloudUploadIcon> Subir documento </label>
                        <input id={props.objRef} type="file" name={props.objRef} onChange={changeImagen} variant="contained"/></span>):(<span><button className="btn btn-success m-1" onClick={uploadImage}  >Actualizar</button>
                     </span>)
                    }
                       <button className="btn btn-danger m-1" onClick={handleModalClose}  >Cancelar</button>
                    
                    </div>
                 </div>
                
            </Box>
            {
             infoStatus?(<><div className="alert alert-success minimalsize" role="alert"><InfoIcon/>{props.title}</div></>):
                        (<><div className="alert alert-warning  minimalsize" role="alert"><InfoIcon/>Por favor suba un documento</div></>)
            }
           </>)
        }
        </Card>


    )
}